import React, { useState } from "react";
import Wrapper from "../components/Wrapper";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { translations } from "../langauge";
import MobileBottomMenu from "../components/MobileBottomMenu";
import ContactUsLink from "../components/ContactUsLink";

const Pricing = () => {
  const { lang } = useLang();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("online-ordering");

  const PRICING_SECTION_IDS = ["online-ordering", "qr-menu", "point-of-sale", "b2b-ordering", "booking", "sponsored-ads"];
  const sideNavItems = [
    { id: "go-back", title: translations[lang].go_back, isBack: true },
    { id: "online-ordering", title: translations[lang].pricing_online_ordering, isBack: false },
    { id: "qr-menu", title: translations[lang].pricing_qr_menu, isBack: false },
    { id: "point-of-sale", title: translations[lang].pricing_pos, isBack: false },
    { id: "b2b-ordering", title: translations[lang].pricing_b2b, isBack: false },
    { id: "booking", title: translations[lang].pricing_booking, isBack: false },
    { id: "sponsored-ads", title: translations[lang].pricing_sponsored, isBack: false },
  ];
  const sectionIndex = PRICING_SECTION_IDS.indexOf(activeSection);
  const safeSectionIndex = sectionIndex >= 0 ? sectionIndex : 0;
  const pricingSectionTitles = {
    "online-ordering": translations[lang].pricing_online_ordering,
    "qr-menu": translations[lang].pricing_qr_menu,
    "point-of-sale": translations[lang].pricing_pos,
    "b2b-ordering": translations[lang].pricing_b2b,
    "booking": translations[lang].pricing_booking,
    "sponsored-ads": translations[lang].pricing_sponsored,
  };

  const handlePrevSection = () => {
    const prevIndex = (safeSectionIndex - 1 + PRICING_SECTION_IDS.length) % PRICING_SECTION_IDS.length;
    setActiveSection(PRICING_SECTION_IDS[prevIndex]);
  };
  const handleNextSection = () => {
    const nextIndex = (safeSectionIndex + 1) % PRICING_SECTION_IDS.length;
    setActiveSection(PRICING_SECTION_IDS[nextIndex]);
  };

  return (
    <Wrapper>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-4 rightSideDivParent">
          <div className="rightSideDiv">
            <div className="navbarDiv">
              <ul>
                {sideNavItems.map((item) => (
                  <li key={item.id}>
                    {item.isBack ? (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/");
                        }}
                        style={{
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          alt="go back"
                          src="./images/left-arrow.png"
                          style={{
                            marginRight: lang === "en" ? "15px" : 0,
                            marginLeft: lang === "ar" ? "15px" : 0,
                            height: "20px",
                            width: "auto",
                            transform: lang === "ar" ? "rotate(180deg)" : undefined,
                          }}
                        />
                        {item.title}
                      </a>
                    ) : (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveSection(item.id);
                        }}
                        className={activeSection === item.id ? "active" : ""}
                        style={{ textAlign: lang === "ar" ? "right" : "left" }}
                      >
                        {item.title}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-8 col-8 contentDivParent">
          <div className="contentDiv">
            {activeSection === "online-ordering" && (
              <div style={{ textAlign: lang === "ar" ? "right" : "left" }}>
                <h2 className="aboutSectionTitle">
                  {translations[lang].pricing_online_ordering}
                </h2>
                <p className="commonpara">
                  {translations[lang].pricing_online_ordering_intro}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_basic_title} — {translations[lang].pricing_basic_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_basic_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_advanced_title} — {translations[lang].pricing_advanced_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_advanced_desc}
                </p>
                <p className="commonpara" style={{ marginTop: "1rem" }}>
                  <ContactUsLink text={translations[lang].pricing_ready_to_start} />
                </p>
              </div>
            )}
            {activeSection === "qr-menu" && (
              <div style={{ textAlign: lang === "ar" ? "right" : "left" }}>
                <h2 className="aboutSectionTitle">
                  {translations[lang].pricing_qr_menu}
                </h2>
                <p className="commonpara">
                  {translations[lang].pricing_qr_menu_intro}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_qr_just_title} — {translations[lang].pricing_qr_just_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_qr_just_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_qr_ordering_title} — {translations[lang].pricing_qr_ordering_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_qr_ordering_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_qr_unlimited_title} — {translations[lang].pricing_qr_unlimited_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_qr_unlimited_desc}
                </p>
                <p className="commonpara" style={{ marginTop: "1rem" }}>
                  <ContactUsLink text={translations[lang].pricing_ready_to_start} />
                </p>
              </div>
            )}
            {activeSection === "point-of-sale" && (
              <div style={{ textAlign: lang === "ar" ? "right" : "left" }}>
                <h2 className="aboutSectionTitle">
                  {translations[lang].pricing_pos}
                </h2>
                <p className="commonpara">
                  {translations[lang].pricing_pos_intro}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_pos_1_2_title} — {translations[lang].pricing_pos_1_2_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_pos_1_2_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_pos_5_title} — {translations[lang].pricing_pos_5_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_pos_5_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_pos_10_title} — {translations[lang].pricing_pos_10_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_pos_10_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_pos_more_title} — <ContactUsLink text={translations[lang].pricing_pos_more_desc} />
                </h4>
                <p className="commonpara" style={{ marginTop: "1rem" }}>
                  <ContactUsLink text={translations[lang].pricing_ready_to_start} />
                </p>
              </div>
            )}
            {activeSection === "b2b-ordering" && (
              <div style={{ textAlign: lang === "ar" ? "right" : "left" }}>
                <h2 className="aboutSectionTitle">
                  {translations[lang].pricing_b2b}
                </h2>
                <p className="commonpara">
                  {translations[lang].pricing_b2b_intro}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_b2b_10_title} — {translations[lang].pricing_b2b_10_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_b2b_10_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_b2b_20_title} — {translations[lang].pricing_b2b_20_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_b2b_20_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_b2b_more_title} — <ContactUsLink text={translations[lang].pricing_b2b_more_desc} />
                </h4>
                <p className="commonpara" style={{ marginTop: "1rem" }}>
                  <ContactUsLink text={translations[lang].pricing_ready_to_start} />
                </p>
              </div>
            )}
            {activeSection === "booking" && (
              <div style={{ textAlign: lang === "ar" ? "right" : "left" }}>
                <h2 className="aboutSectionTitle">
                  {translations[lang].pricing_booking}
                </h2>
                <p className="commonpara">
                  {translations[lang].pricing_booking_intro}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_booking_flex_title} — {translations[lang].pricing_booking_flex_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_booking_flex_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_booking_fixed_title} — {translations[lang].pricing_booking_fixed_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_booking_fixed_desc}
                </p>
                <p className="commonpara" style={{ marginTop: "1rem" }}>
                  <ContactUsLink text={translations[lang].pricing_ready_to_start} />
                </p>
              </div>
            )}
            {activeSection === "sponsored-ads" && (
              <div style={{ textAlign: lang === "ar" ? "right" : "left" }}>
                <h2 className="aboutSectionTitle">
                  {translations[lang].pricing_sponsored}
                </h2>
                <p className="commonpara">
                  {translations[lang].pricing_sponsored_intro}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_sponsored_instagram_title} — {translations[lang].pricing_sponsored_instagram_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_sponsored_instagram_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_sponsored_tiktok_title} — {translations[lang].pricing_sponsored_tiktok_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_sponsored_tiktok_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_sponsored_snapchat_title} — {translations[lang].pricing_sponsored_snapchat_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_sponsored_snapchat_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_sponsored_google_title} — {translations[lang].pricing_sponsored_google_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_sponsored_google_desc}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].pricing_sponsored_whatsapp_title} — {translations[lang].pricing_sponsored_whatsapp_price}
                </h4>
                <p className="commonpara">
                  {translations[lang].pricing_sponsored_whatsapp_desc}
                </p>
                <p className="commonpara" style={{ marginTop: "1rem" }}>
                  <ContactUsLink text={translations[lang].pricing_sponsored_contact} />
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <MobileBottomMenu
        title={pricingSectionTitles[activeSection] ?? translations[lang].pricing_online_ordering}
        withTabs
        sectionIndex={safeSectionIndex}
        sectionCount={PRICING_SECTION_IDS.length}
        onPrev={handlePrevSection}
        onNext={handleNextSection}
      />
    </Wrapper>
  );
};

export default Pricing;
